import actions from '@/vuex/modules/pointGroupOperation/actions'
import getters from '@/vuex/modules/pointGroupOperation/getters'
import mutations from '@/vuex/modules/pointGroupOperation/mutations'
import { editMode } from '@/components/Advertiser/Operation/PointGroup/PointGroupOperation/constants'
import cloneDeep from 'lodash/cloneDeep'

export const initialState = {
  groupList: [],
  editMode: {
    mode: editMode.SELECT_GROUP,
    initialTargetGroup: { id: null, name: null, locationType: null },
    currentTargetGroup: { id: null, name: null, locationType: null }, // 編集された groupName 等を保持する1
    pagePermission: null,
    targetGroupType: null,
    loadingPointList: false,
    initialPointList: [], // フェッチしてきたデータを保持
    currentPointList: [], // 編集された結果の現在の UI のデータを保持
    pointListForUI: [], // 変更されたかどうかも含んだ UI 用の情報
    selectedPoint: {
      id: null,
      name: null,
      newItem: {
        id: null,
        new: false,
      },
      longitude: 139.7009177,
      latitude: 35.6580971,
    },
    mapCenter: {
      longitude: 139.7009177,
      latitude: 35.6580971,
    },
    newItemId: 0, // 新規追加のアイテムを識別するためのフロントで一時的に使う ID
    isEditingPoiCategory: false, // カテゴリーグループのPOI地点編集エリアの表示に使用
    lastDragEndTime: null, // ドラッグ終わり直後のmap clickを抑制するために使う
    search: {
      query: '',
      resultList: [],
      currentResultIndex: null,
    },
  },
  locationFilter: 'all',
  map: null,
  mapLoaded: false,
  pointListInFrameCount: null,
  fitBounds: false,
}

const pointGroupOperation = {
  namespaced: true,
  state: cloneDeep(initialState),
  getters,
  actions,
  mutations,
}

export default pointGroupOperation
